import React from 'react';
import {TableRow, TableRowColumn} from 'material-ui/Table';
import FlatButton from 'material-ui/FlatButton';

export default function CategoryRow(props) {
  return (
    <TableRow key={props.category._id}>
      <TableRowColumn style={{whiteSpace:'normal', width:'60px'}}>{props.category._id}</TableRowColumn>
      <TableRowColumn style={{whiteSpace:'normal'}}>{props.category.friendlyName}</TableRowColumn>
      <TableRowColumn style={{whiteSpace:'normal'}}>{props.category.name}</TableRowColumn>
      <TableRowColumn style={{whiteSpace:'normal'}}>{props.category.searchTerms}</TableRowColumn>
      <TableRowColumn style={{whiteSpace:'normal', width:'90px'}}>
        <FlatButton label="Muokkaa" onTouchTap={() => props.onCategorySelected(props.rowNumber)}/>
      </TableRowColumn>
    </TableRow>
  );
}



// WEBPACK FOOTER //
// ./src/components/CategoriesPage/CategoryRow.js